import { AxiosError, AxiosInstance } from 'axios';

import BookingPage, {
  BookingPageBookable,
  BookingPageList,
} from '../../domain/entities/BookingPage';
import API_ROOT from '../../utils/api';
import securedAxios, { newSecuredAxios } from '../../utils/secured-axios';

/**
 * NOTE: use coubic v2 api
 */

const searchQueryString = (page?: string, via?: string) => {
  const pageParam = page ? `page=${page}` : '';
  const viaParam = via ? `via=${via}` : '';
  if (pageParam && viaParam) {
    return `?${pageParam}&${viaParam}`;
  }
  if (pageParam && !viaParam) {
    return `?${pageParam}`;
  }
  if (!pageParam && viaParam) {
    return `?${viaParam}`;
  }
  return '';
};

export class BookingPageRepository {
  private api: AxiosInstance;

  constructor(api: AxiosInstance) {
    this.api = api;
  }

  public async Find(
    merchantId: string,
    bookingPagePublicId: string,
  ): Promise<BookingPage> {
    const path = `${API_ROOT}/merchants/${merchantId}/booking_pages/${bookingPagePublicId}`;

    return this.api
      .get(path)
      .then(response => {
        return new BookingPage(response.data);
      })
      .catch((err: AxiosError) => {
        return Promise.reject(err);
      });
  }

  public async Search(
    merchantId: string,
    page?: string,
    via?: string,
  ): Promise<BookingPageList> {
    const queryString = searchQueryString(page, via);
    const path = `${API_ROOT}/merchants/${merchantId}/booking_pages${queryString}`;

    return this.api
      .get(path)
      .then(response => {
        return new BookingPageList(response.data);
      })
      .catch((err: AxiosError) => {
        return Promise.reject(err);
      });
  }

  public async Bookable(
    merchantId: string,
    bookingPagePublicId: string,
  ): Promise<BookingPageBookable> {
    const path = `${API_ROOT}/merchants/${merchantId}/booking_pages/${bookingPagePublicId}/bookable`;

    return this.api
      .get(path)
      .then(response => {
        return new BookingPageBookable(response.data);
      })
      .catch((err: AxiosError) => {
        return Promise.reject(err);
      });
  }
}

export default new BookingPageRepository(securedAxios);

// SSRでAPIリクエストを行いたい場合、session情報を明示的に載せる必要があるため、
// こっちのメソッドから生成されたインスタンスを利用する
// まだ必要な箇所が限定的なので自前実装で対応しているが、ゆくゆくは
// https://github.com/maticzav/nookies
// みたいなライブラリを利用して、あまり意識しなくてもこの辺が達成される方向に持っていきたい
export const BookingPageRepositoryForSSR = (
  session: string,
  token: string,
  requestId: string,
) => {
  return new BookingPageRepository(newSecuredAxios(session, token, requestId));
};
